import { genericFilterSummary } from "../../utils/devextreme_utils";

/**
 * @returns {import("../datagrid").Plugin}
 */
export function columnFiltersPlugin() {
  return ($container) => {
    const $filterAmountButton = $container.querySelector(".js-filter-amount-button");
    const $filterAmountBadge = $container.querySelector(".js-filter-amount-badge");
    if ($filterAmountButton === null || $filterAmountBadge === null) {
      console.warn("Filter amount button or badge could not be found");
    }

    return {
      id: "columnFilters",

      options: {
        filterRow: {
          visible: true,
        },
      },

      onDataGridCreated() {
        $filterAmountButton.addEventListener("click", () => this.clearFilter());
      },
      onContentReady() {
        genericFilterSummary(this, {
          $button: $filterAmountButton,
          $badge: $filterAmountBadge,
        });
      },
    };
  };
}
